<template>
  <span v-if="!!data">
      <template v-if="!tip">
        对比同版位同类型产品出价均值
       <span class="red">{{data}}</span>
     </template>
     <template v-else>
      <template v-if="data ==='0'">
        与同版位同类型产品出价均值 <span class="red">一致</span>
      </template>
     </template>
  </span>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {}
  },
  computed: {
    tip() {
      return  ['--', '0'].includes(this.data)
    }
  }
}
</script>

<style lang="scss" scoped>
.red {
  color: red;
}
</style>